import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { getPrefetchedExperimentsSelector } from './getPrefetchedExperimentsSelector';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../constants/oneXpConstants';

export const getOneCMSUrl = (state) => state.getIn(['config', 'oneCMSInternetSSRBaseUrl']);

export const getOneCmsFilePath = createSelector(
  getOneCMSUrl,
  getActiveLocaleSelector,
  (oneCMSInternetSSRBaseUrl, activeLocale) => `${oneCMSInternetSSRBaseUrl}/Internet/travel/consumer-travel/${activeLocale?.toLowerCase()}/`
);

export const getFullOneCmsUrl = createSelector(
  getOneCmsFilePath,
  getPrefetchedExperimentsSelector,
  (oneCmsFilePath, experiments) => {
    const homepageVariant = experiments?.[HOMEPAGE_REDESIGN_EXPERIMENT]?.dimensions?.search_widget;
    const isVariantEnabled = !!homepageVariant && homepageVariant !== 'control';
    return `${oneCmsFilePath}${isVariantEnabled ? 'travel-homepage' : 'homepage'}.json`;
  }
);
